import React from "react";
import "./Screen.css";

const Screen = ({ expression, value, degMode }) => {
  return (
    <div className="screen">
      <div className="screen__top">
        <span className="screen__mode">{degMode ? "DEG" : "RAD"}</span>
        <span className="screen__expression">{expression}</span>
      </div>
      <div className="screen__value">{value}</div>
    </div>
  );
};

export default Screen;
